import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/lib/lang";

export default function SearchBar({ value, onChange, results, onPick }) {
  const { t, lang } = useLang();

  return (
    <div className="glass rounded-full flex items-center gap-2 pl-4 pr-2 py-1.5 w-full max-w-lg relative">
      <Search size={16} className="text-[#8b6f3d] shrink-0" />
      <Input
        data-testid="search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("searchPlaceholder")}
        className="border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 text-zinc-900 placeholder:text-zinc-400 text-sm h-8"
      />
      {value && (
        <button onClick={() => onChange("")} data-testid="clear-search-btn" className="p-1.5 rounded-full hover:bg-zinc-100 text-zinc-500">
          <X size={14} />
        </button>
      )}
      {value && results?.length > 0 && (
        <div className="absolute top-[110%] left-0 right-0 glass rounded-2xl overflow-hidden max-h-80 overflow-y-auto z-[1000]">
          <div className="p-2 text-[10px] font-mono-data uppercase tracking-wider text-zinc-500 border-b border-zinc-100">
            {results.length} {t("resultsFound")}
          </div>
          {results.slice(0, 12).map((loc) => (
            <button
              key={loc.id}
              onClick={() => onPick(loc)}
              data-testid={`search-result-${loc.id}`}
              className="w-full text-left px-4 py-3 hover:bg-zinc-50 border-b border-zinc-100 last:border-0 flex items-center gap-3 transition-colors"
            >
              <div className="flex-1">
                <div className="text-sm text-zinc-900">{loc.name?.[lang] || loc.name?.fr}</div>
                <div className="text-[11px] text-zinc-500 font-mono-data">{loc.country}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
